import React from 'react'
import { UILayout, UIText } from 'bora-material-ui'
import styles from './SaaremaaFooter.module.scss'

const currentYear = new Date().getFullYear()

const SaaremaaFooter = () => (
  <UILayout
    data-testid="saaremaa-footer"
    j-flex-center
    align="center"
    zIndex="100"
    height="60px"
    width="100vw"
    style={{ marginTop: 'auto', fontFamily: styles.fontFamily }}
  >
    <span style={{ fontWeight: '200' }}>&copy; {currentYear} Saaremaa Vallavalitsus | &nbsp;</span>
    <a href="https://bora.systems" target="_blank" style={{ textDecoration: 'none' }}>
      <UIText text="Powered by Bora Systems" color={styles.openNavIcon} weight="400" />
    </a>
  </UILayout>
)

export default SaaremaaFooter
